/* eslint eol-last: ["error", "never"] */
export default {
    loading: false,
    agendas: [],
}